import { tv } from "@opensea/ui-kit"

/**
 * Convenience class for having full bleed content based on the page container's padding.
 */
export const fullBleedVariants = tv({
  base: "-mx-4 lg:-mx-6 relative w-[stretch]",
  variants: {
    width: {
      fullWidth: "",
      fullScreen: "",
    },
    withTopNav: {
      true: "-mt-sm-top-nav lg:-mt-lg-top-nav",
    },
    mobileOnly: {
      true: "lg:mx-0",
      false: "",
    },
  },
  compoundVariants: [
    {
      width: "fullWidth",
      mobileOnly: false,
      className:
        // One extra pixel due to differences between Mac and Windows scrollbars
        "4xl:mx-[min(calc(((100%-theme(screens.4xl))/2)*-1+5px),-24px)]",
    },
    {
      width: "fullScreen",
      mobileOnly: false,
      className:
        // One extra pixel due to differences between Mac and Windows scrollbars
        // 52px is the width of the sidebar
        "4xl:mx-[min(calc(((100vw-theme(spacing.side-nav)-theme(screens.4xl))/2)*-1+(theme(spacing.root-scroll-bar-size)/2)),-24px)]",
    },
  ],
  defaultVariants: {
    width: "fullScreen",
    mobileOnly: false,
  },
})

export const fullHeightVariants = tv({
  base: "h-[calc(100vh-theme(spacing.sm-top-nav))] min-h-[calc(100vh-theme(spacing.sm-top-nav))] lg:h-[calc(100vh-theme(spacing.lg-top-nav)-theme(spacing.page-footer))] lg:min-h-[calc(100vh-theme(spacing.lg-top-nav)-theme(spacing.page-footer))]",
})
